<template>
    <div class="analytics-perfection-total">
        <span class="analytics-perfection-total__art"></span>
        <div class="analytics-perfection-total__heading">
            <h2 class="analytics-perfection-total__heading-h2">Nihai Kusursuzluk</h2>
            <p class="analytics-perfection-total__heading-desc">Ünlü ve ünsüz sesbirim ve değişkelerde topladığın elmasların toplamıyla hesaplanan kusursuzluk oranın</p>
        </div>
        <div class="analytics-perfection-total__wr-progressbar">
            <span class="analytics-perfection-total__separator--top-left"></span>
            <span class="analytics-perfection-total__separator--top-right"></span>
            <span class="analytics-perfection-total__wr-value">
                <div v-if="showPreloader" class="analytics-perfection-total__preloader"></div>
                <template v-if="!showPreloader">
                    <span class="analytics-perfection-total__value">%{{ perfectionTotalData.value }}</span>
                    <span class="analytics-perfection-total__label">KUSURSUZLUK</span>
                </template>
            </span>
            <div :style="progressbarWidth" class="analytics-perfection-total__progressbar"></div>
            <span class="analytics-perfection-total__separator--bot-left"></span>
            <span class="analytics-perfection-total__separator--bot-right"></span>
        </div>
    </div>
</template>
<script>
    export default {
        data(){
            return {
                showPreloader: true,
            };
        },

        computed: {
            perfectionTotalData(){
                return this.$store.state.response.analyticsPerfection.perfectionTotalData;
            },

            progressbarWidth(){
                if(this.showPreloader){
                    return `background-size: 1px 100%, 1px 100%, 1px 100%, 100% 100%, auto;`
                }
                let width = 100 - this.perfectionTotalData.value;
                return `background-size: 1px 100%, 1px 100%, 1px 100%, ${width}% 100%, auto;`
            },
        },

        mounted(){
            if(this.$store.state.envDev){
                this.showPreloader = true;
                fetch(this.$store.state.jsonServer.analyticsPerfectionTotal)
                .then(response => response.json())
                .then(perfectionTotalData => {
                    this.$store.commit('setResponse', {
                        categoryLabel: 'analyticsPerfection',
                        dataLabel: 'perfectionTotalData',
                        data: perfectionTotalData
                    });
                    this.showPreloader = false;
                });
            }
            else{
                this.showPreloader = true;
                fetch(this.$store.state.api.analyticsPerfectionProgressTotal, {
                    method: 'GET',
                    credentials: 'include'
                })
                .then(async response => {
                    if(response.status !== 200){
                        throw await response.json();
                    }
                    return response.json();
                })
                .then(perfectionTotalData => {
                    this.$store.commit('setResponse', {
                        categoryLabel: 'analyticsPerfection',
                        dataLabel: 'perfectionTotalData',
                        data: perfectionTotalData
                    });
                    this.showPreloader = false;
                })
                .catch(err => {
                    this.$foneturkError({
                        text: 'Bir şeyler ters gitti.'
                    });
                    console.error(err);
                });
            }
        }
    };
</script>
<style scoped src="@/css/components/analytics-perfection-total.css"></style>
